const root = 'https://www.abillion.com'
const abv = ' | abillion'

const meta = {
  abv,
  // ambassadors
  ambassadors: {
    home: {
      title: `Ambassadors Program Dashboard - Home${abv}`,
      description:
        'Ambassadors Program - view your audience stats and progress to your next payment',
      keywords: 'ambassadors, dashboard, home, audience, payment, progress',
      url: `${root}/dashboard/home`
    },
    feed: {
      title: `Ambassadors Program Dashboard - Feed${abv}`,
      description: 'Ambassadors Program - engage with your audience',
      keywords: 'ambassadors, dashboard, feed, audience, reviews, posts',
      url: `${root}/dashboard/feed`
    },
    resources: {
      title: `Ambassadors Program Dashboard - Resources${abv}`,
      description:
        'Ambassadors Program - resources to grow, share and engage with your audience',
      keywords:
        'ambassadors, dashboard, resources, social, logo, links, share, affiliate',
      url: `${root}/dashboard/resources`
    },
    account: {
      title: `Ambassadors Program Dashboard - Account${abv}`,
      description:
        'Ambassadors Program - update your details and view your payment history',
      keywords:
        'ambassadors, dashboard, account, payment history, personal details, paypal',
      url: `${root}/dashboard/account`
    },
    faq: {
      title: `Ambassadors Program Dashboard - FAQ${abv}`,
      description: 'Ambassadors Program - frequently asked questions',
      keywords: 'ambassadors, dashboard, faq, frequently asked questions',
      url: `${root}/dashboard/faq`
    },
    contact: {
      title: `Ambassadors Program Dashboard - Contact Us${abv}`,
      description: 'Ambassadors Program - contact us',
      keywords: 'ambassadors, dashboard, contact',
      url: `${root}/dashboard/contact`
    },
    login: {
      title: `Ambassadors Program Dashboard - Log in${abv}`,
      description: 'Ambassadors Program - log in',
      keywords: 'ambassadors, dashboard, login',
      url: `${root}/login`
    }
  },
  // auth
  forgot: {
    title: `Reset password${abv}`,
    description: 'Reset your lost/forgotten password.',
    keywords: 'forgot, password, reset',
    url: `${root}/dashboard/home`
  },
  // auth
  reset: {
    title: `Choose a new password${abv}`,
    description: 'Choose a new password.',
    keywords: 'reset, password, forgot, token',
    url: `${root}/auth/reset`
  },
  ambassadorIndex: {
    title: `Join our Ambassador referral Program${abv}`,
    description:
      'Join our Ambassador referral program. Inspire people to choose vegan and to review plant-based food & products on abillion. Get rewarded every single time!',
    keywords:
      'affiliate program, referral program, ambassador program, money, vegan, review, rating, food, dish, products, brands, reward, influencer, community, app, earn',
    url: `${root}/ambassadors`
  },
  ambassadorJoin: {
    title: `Ambassadors Program${abv}`,
    description: 'Sign up to lead the charge in our mindful movement',
    keywords:
      "ambassador's program, frequently asked questions, faq, influencer, referral",
    url: `${root}/join`
  },
  brand: {
    title: '',
    description: '',
    keywords:
      'vegan, plant-based, sustainability, cruelty-free, products, reviews, rating',
    url: `${root}/brands/`
  },
  dish: {
    title: '',
    description: '',
    keywords:
      'vegan, plant-based, dishes, restaurants, reviews, near me, rating',
    url: `${root}/dishes/`
  },
  faq: {
    title: `Ambassadors Program - FAQ${abv}`,
    description: "Frequently asked questions about the Ambassador's Program.",
    keywords:
      "ambassador's program, frequently asked questions, faq, influencer, referral",
    url: `${root}/ambassador/faq`
  },
  feed: {
    title: `Feed - Find plant-based inspiration${abv}`,
    description:
      'Scroll through plant-based dishes, follow your favorites, and be inspired.',
    keywords: 'feed, reviews, follow, plant-based, inspiration',
    url: `${root}/feed`,
    robots: 'noindex'
  },
  hashtag: {
    title: '#',
    description: 'See all reviews tagged as #',
    keywords: 'hashtags, trending, reviews, vegan, plant-based, rating',
    url: `${root}/hashtags/`,
    robots: 'noindex'
  },
  // no policy found
  noPolicyFound: {
    title: `No policy found${abv}`,
    description: '',
    keywords: 'policies',
    url: `${root}/policies`
  },
  justDonated: {
    title: 'Driving change, one review at a time',
    description:
      'Given to impactful causes or invested into abillion by members',
    keywords: 'challenge, donated, impact',
    url: `${root}/challenge/just-donated`
  },
  partners: {
    title: `Our Non-Profit Partners${abv}`,
    description:
      'Review vegan products & plant-based food to donate to the world’s most impactful NGOs. Support our 50+ partners around the world. Make an impact today!',
    keywords:
      'animal sanctuaries, animal rescue, human rights, NGO, vegan, food, cruelty-free products, donation, reviews, rating, community, social impact, Singapore, South Africa, USA, UK, Australia, New Zealand, Germany',
    url: `${root}/partners`
  },
  post: {
    title: `Write a review - Share your opinion and give feedback${abv}`,
    description:
      'Post a review of your plant-based dish or product to share with others and give feedback to businesses',
    keywords: 'vegan, plant-based, review, dish, product, rating',
    url: `${root}/posts/`,
    robots: 'noindex'
  },
  listing: {
    url: `${root}/listings/`
  },
  product: {
    title: '',
    description: '',
    keywords:
      'vegan, plant-based, sustainability, cruelty-free, products, brands, reviews, rating',
    url: `${root}/products/`
  },
  restaurant: {
    title: '',
    description: '',
    keywords: 'vegan, plant-based, restaurants, reviews, near me, rating',
    url: `${root}/restaurants/`
  },
  review: {
    title: 'Review by',
    description: '',
    keywords: 'vegan, plant-based, review, rating',
    url: `${root}/reviews/`
  },
  user: {
    title: '',
    description: 'Check out @',
    keywords: 'users, profile, reviews, vegan, plant-based',
    url: `${root}/users/`
  },
  search: {
    title: `Search anything vegan around you${abv}`,
    description:
      'Search for vegan brands, recipes & restaurant reviews near you. Join our growing community of conscious consumers and learn more about the plant-based lifestyle!',
    keywords:
      'vegan, finder, restaurant, food, people, recipes, plant-based, sustainability, cruelty-free, products, dishes, animal, donation, reviews, rating, near me, community, app',
    url: `${root}/search/`,
    robots: 'noindex'
  },
  settings: {
    title: `Profile settings${abv}`,
    description:
      'Edit your abillion profile and picture, change your password, and manage your profile settings.',
    keywords: 'users, settings, change, edit, profile, update',
    url: `${root}/settings`
  },
  notFound: {
    title: `404 - Not Found${abv}`,
    description: '404 - Not found',
    keywords: 'error, 404, not found',
    url: root
  },
  internalError: {
    title: `500 - Internal Server Error${abv}`,
    description: '500 - Internal server error',
    keywords: 'error, 500',
    url: root
  }
}

export default meta
